import { Input } from '@seiue/ui'
import { InputProps } from 'antd'
import React from 'react'
import styled from 'styled-components'

import { GrowpIcon } from '../GrowpIcon'

export const InputSearch: React.FC<
  InputProps & {
    onClear?: () => void
  }
> = ({ onClear, onChange, ...rest }) => {
  return (
    <Wrapper>
      <Input
        style={{
          width: '320px',
        }}
        prefix={<GrowpIcon name="Search" />}
        onChange={(e) => {
          const v = e.target.value
          if (!v && onClear) {
            onClear()
            return
          }
          onChange && onChange(e)
        }}
        {...rest}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  &&& {
    .ant-input-affix-wrapper {
      border-radius: 8px;
      border-color: transparent;
      background-color: ${(props) => props.theme.background._3};
      &:hover:not(.ant-input-affix-wrapper-focused),
      &:hover:not(.ant-input-affix-wrapper-focused) .ant-input {
        background-color: ${(props) => props.theme.background._2};
      }
      &:focus {
        border-color: ${(props) => props.theme.brand._1} !important;
        background-color: ${(props) => props.theme.background._3} !important;
      }

      .ant-input {
        background-color: ${(props) => props.theme.background._3};
      }
    }
    .ant-input-affix-wrapper-focused {
      border-color: ${(props) => props.theme.brand._1};
      background-color: transparent;
      & .ant-input {
        background-color: transparent;
      }
    }
  }
`
